// ##### 25-02-05 Komarov
import { Select } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../../../hooks/useLocalizedText.js';
import { GuideTypes } from '../../../../../StaticJsonData/GuideTypes';

// ##### Komarov 2025-07-14
const GuideAssistantComponent = ({ props }) => {
  const { selectGuideTypes, guideTypes, guideTypesTypesInitialState } = props;
  // ##### Komarov 2025-08-05
  const chooseGuideLanguage = useLocalizedText('ChooseGuideLanguage');
  // ##### 25-05-19 Komarov
  const SupplierForm_PleaseSelect = useLocalizedText('SupplierForm_PleaseSelect');
  const locale = useSelector(state => state.language);

  return (
    <div className="groupTravelblocks_2" key={uniqueId()}>
      <span>
        {/* ##### 23-09-07 Komarov */}
        {chooseGuideLanguage}
      </span>
      <Select
        onChange={selectGuideTypes}
        bordered={true}
        style={{ minWidth: '5vw' }}
        // ##### 24-03-21 Komarov
        value={
          (guideTypes === guideTypesTypesInitialState &&
            SupplierForm_PleaseSelect) ||
          guideTypes
        }
      >
        <>
          {
            // ##### 24-03-21 Komarov
            GuideTypes(locale)?.map(item => {
              return (
                <Option value={item} key={item}>
                  {item}
                </Option>
              );
            })
          }
        </>
      </Select>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default GuideAssistantComponent;
